import * as $http from 'axios'

export default {
    detail: userId => $http.get(`v2/users/${userId}`),
    me: () => $http.get('v2/users/me'),
    chunkedNotifications: offset => $http.get(`users/chunked_notifications?offset=${offset}`),
    banNoOnsCampaign: userId => $http.put(`v2/users/${userId}/no_ons_campaign`),
    registerDevice: payload => $http.post('users/register_device', payload),
    badges: userId => $http.get(`v2/users/${userId}/badge`),
    deleteToken: registrationId => $http.post('users/logout_delete_token', { registration_id: registrationId }),
    findChat: userId => $http.get(`v2/users/${userId}/find_chats`),
    rating: userId => $http.get(`v2/users/${userId}/user_ratings`),
    // 주선자가 유저 appearance_rate 평가 시, request_type = 1을 준다.
    updateAppearanceRating: (userId, requestType, appearanceRate) =>
        $http.post(`v2/users/${userId}/user_ratings`, { request_type: requestType, appearance_rate: appearanceRate }),
    checkNickname: nickname => $http.get(`v2/users/check_nickname?nickname=${nickname}`),
    checkEmail: email => $http.get(`v2/users/check_email?email=${email}`),
    create: payload => $http.post('v2/users', payload),
    reportUser: {
        create: (userId, payload) => $http.post(`v2/users/${userId}/report_users`, payload),
        update: (userId, reportUserId, payload) =>
            $http.put(`v2/users/${userId}/report_users/${reportUserId}`, payload),
    },
    acceptedHistory: userId => $http.get(`v2/users/${userId}/accepted_history`),
}
